// src/components/common/styles.js
// Reusable style helpers for layout and alignment

export const flexRowCenter = {
  display: 'flex',
  alignItems: 'center',
};

export const flexRowWrap = (theme) => ({
  ...flexRowCenter,
  flexWrap: 'wrap',
  gap: theme.spacing(0.5),
});

export const dialogTitle = {
  ...flexRowCenter,
  justifyContent: 'space-between',
};
